<template>
    <v-card class="mb-3">
        <v-card-text
            v-for="(property, index) in properties"
            :key="index"
            :class="index % 2 === 0 ? 'pb-0' : 'pt-0'"
        >
            <summary-value
                :object="benefits"
                :property="property"
                small
            ></summary-value>

            <v-divider
                class="my-4"
                v-if="index !== (properties.length - 1)"
            ></v-divider>
        </v-card-text>
    </v-card>
</template>

<script>
    import SummaryValue from './../../Global/SummaryValue';

    import KeyPlanMixin from "./../keyplan";

    export default {
        name: "KeyPlanMobileSummary",

        mixins: [
            KeyPlanMixin
        ],

        components: {
            SummaryValue
        },

        data() {
            return {
                properties: [
                    'keyplanMaxBenefit',
                    'keyplanPremium',
                ]
            }
        },
    }
</script>
